module.exports = __webpack_public_path__ + "img/s14.52de60ee.png";